module.exports = __webpack_public_path__ + "img/house-door-fill.ed87894c.svg";